import brandDefault from '../../../brand.json';
import { buildAppConfig as buildShared, type RuntimeConfig as SharedRuntimeConfig } from '@atsa/shared';

/**
 * Config de runtime del sitio de afiliados. Misma mecanica que el sitio de
 * empresas (ver `@atsa/shared`): brand.json del bundle + /config.js montado.
 */

export type Brand = typeof brandDefault;
export type RuntimeConfig = SharedRuntimeConfig<Brand>;

declare global {
  interface Window {
    __APP_CONFIG__?: RuntimeConfig;
  }
}

export function buildAppConfig(runtime: RuntimeConfig | undefined, env: Record<string, string | undefined>) {
  return buildShared(brandDefault, runtime, env);
}

export const appConfig = buildAppConfig(
  typeof window !== 'undefined' ? window.__APP_CONFIG__ : undefined,
  import.meta.env as unknown as Record<string, string | undefined>,
);

export const brand = appConfig.brand;
